/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListContentVideo Input Action
 */
export class GetCmsListContentVideoInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_LIST_CONTENT_VIDEO`;
    public getCacheObjectType = () => 'CMS_LIST_CONTENT_VIDEO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsListContentVideoData {
    totalItem: any;
    dataCms: AttributeValue[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsListContentVideoInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCmsListContentVideoInput, ctx: Msdyn365.IActionContext): Promise<IGetCmsListContentVideoData | null> {
    let pageID: string = '';
    let pathName: string = '';
    let searchParam: string = '';
    if (ctx && ctx.requestContext && ctx.requestContext.url && ctx.requestContext.url.requestUrl) {
        pathName = ctx.requestContext.url.requestUrl.pathname;
        const pieces = pathName.split(/[\s\/]+/);
        pageID = pieces[pieces.length - 1];
        searchParam = ctx.requestContext.url.requestUrl.search;
    }
    if (pageID !== '') {
        const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
        const requestUrl = `${frontApiEndpoint}/api/list/node--${pageID}/en${searchParam}`;

        const result = await Msdyn365.sendRequest<IGetCmsListContentVideoData>(requestUrl, 'get')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                ctx.trace('[GetCmsListContentVideo] Failed to get list video.');
                throw error;
            });
        return result;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsListContentVideoData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsListContentVideo',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
